import i18n from '@/i18n'

const { t } = i18n.global

export const ALERT_CLASS_LABELS = [t('alerts.labels.class.alarm'), t('notifications.singular')]

export const ALERT_LEVEL_LABELS = [
  t('organisations.singular'),
  t('sites.singular'),
  t('batteryBanks.singular'),
  t('batteries.singular'),
  t('energyConsumers.singular'),
]

export const ALERT_SEVERITY_LABELS = [
  t('alerts.labels.severity.info'),
  t('alerts.labels.severity.low'),
  t('alerts.labels.severity.medium'),
  t('alerts.labels.severity.high'),
  t('alerts.labels.severity.critical'),
]

export const ALERT_STATUS_LABELS = [t('alerts.statusOptions.ongoing'), t('alerts.statusOptions.closed')]

export const UNITS = {
  AMPERE: 'A',
  AMPERE_HOURS: 'Ah',
  CO2E: 'kgCO2e',
  DEGREE: '°',
  KILO_VOLT_AMPERE: 'kVA',
  KILO_VOLT_AMPERE_HOUR: 'kVAh',
  KILOWATT: 'kW',
  KILOWATT_HOUR: 'kWh',
  KILOWATT_PEAK: 'kWp',
  KILOMETER: 'km',
  LITRE: 'L',
  PERCENTAGE: '%',
  SIGNAL_STRENGTH: 'dBm',
  TEMPERATURE: '°C',
  VOLTAGE: 'V',
  WATT: 'W',
}
